import { Routes } from "@angular/router";
import { authGuard } from "../guards/auth.guard";

export const routes: Routes = [
    { path: '', loadChildren: () => import('../modules/lobby/lobby.module').then(m => m.LobbyModule) },
    { path: 'auth', loadChildren: () => import('../modules/auth/auth.module').then(m => m.AuthModule) },
    {
        path: 'conversation',
        canActivate: [ authGuard ],
        loadComponent: () => import('../modules/conversation/conversation-shell.component').then(m => m.ConversationShellComponent),
        children: [
            { path: '', loadChildren: () => import('../modules/chat/chat.module').then(m => m.ChatModule) },
            { path: 'group', loadChildren: () => import('../modules/group-chat/group-chat.module').then(m => m.GroupChatModule) },
        ],
    },
];
